import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '../../components/Button';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { apiUser } from '../../api/apiUser.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import DotSpinner from '../../components/shared/DotSpinner';
import QRCode from 'react-qr-code';

function ProfileMenu() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [inviteCode, setInviteCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    apiUser
      .getReferralLink(axiosPrivate)
      .then((res) => setInviteCode(res.data.link))
      .finally(() => setIsLoading(false));
  }, []);

  const handleCopy = () => {
    if (!inviteCode) return;
    navigator.clipboard
      .writeText(inviteCode)
      .then(() => {
        toast.success('Скопировано');
      })
      .catch((err) => {
        toast.error('Ошибка копирования');
        console.error('Ошибка копирования: ', err);
      });
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[100vh]">
        <DotSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center justify-center relative text-white text-[24px] w-full pb-[21px] pt-[26px] border-b border-[#233636]">
        <div className="w-full flex justify-center items-center relative">
          <img
            alt="Назад"
            src="/icons/Button-back.svg"
            onClick={() => {
              navigate(-1);
            }}
            className="absolute left-4 w-[44px] h-[44px]"
          />
          <p className="">Пригласить</p>
        </div>
      </div>

      <div className="p-4 font-raleway mb-24 space-y-4">
        <img alt="Информация о приглашении" src="/icons/invite_info_block.svg" className="w-full" />
        <div className="rounded-3xl border border-[#233636] bg-[#022424] p-6 flex flex-col items-center">
          <p className="w-full text-center text-[20px] font-semibold mb-[20px] text-white">Отсканируйте QR-код</p>
          <QRCode
            size={240}
            className="border-[5px] p-3 rounded-2xl border-white"
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={inviteCode ?? ''}
            level="M"
            viewBox={`0 0 256 256`}
            bgColor="#022424"
            fgColor="#ffffff"
          />
        </div>
        <div className="rounded-3xl border border-[#233636] bg-[#022424] p-6 flex flex-col items-center">
          <p className="w-full text-center text-[20px] font-semibold mb-[20px] text-white">Ссылка приглашение</p>
          <div onClick={handleCopy} className="cursor-pointer flex flex-row w-full items-center justify-between gap-2">
            <p className="min-w-0 text-white text-[16px] text-left truncate">{inviteCode}</p>
            <img alt="Копировать" src="/icons/Button-copy.svg" />
          </div>
        </div>
        <div className="text-black fixed bottom-6 left-4 right-4">
          <Button
            onClick={() => {
              // 1. Проверяем, доступен ли Telegram WebApp
              const tg = window.Telegram?.WebApp;

              if (tg && typeof tg.openTelegramLink === 'function') {
                // 2. Формируем ссылку для нативного диалога шаринга
                const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(inviteCode)}&text=${encodeURIComponent('Приглашаю тебя!')}`;

                // 3. Открываем диалог через Telegram
                tg.openTelegramLink(shareUrl);
              } else {
                // 4. Фолбэк для обычных браузеров
                if (navigator.share) {
                  navigator
                    .share({
                      title: 'Пригласить друга',
                      text: 'Приглашаю тебя!',
                      url: inviteCode
                    })
                    .catch((e) => console.error(e));
                } else {
                  toast.error('Ваш браузер не поддерживает данную функцию');
                }
              }
            }}
            className="w-full"
          >
            Отправить
          </Button>
        </div>
      </div>
    </>
  );
}

export default ProfileMenu;
